exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".QouteBlock-module__QuoteBlock___37gcr{padding:16px;border-radius:6px;background-color:hsla(0,0%,100%,.5)}", ""]);

// exports
exports.locals = {
	"QuoteBlock": "QouteBlock-module__QuoteBlock___37gcr"
};